export default "__VITE_ASSET__uJlGOCEG__"